import React from 'react';
import { PhoneOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import { IBook } from '../../../section/Common/types/types';
import { ACTIONS, useActions } from '../../../context/Actions.context';
import { GAEventIdentifier, GAEventName } from '../../../section/Common/constants';

interface IProps {
  book: IBook;
  id: string;
  label?: string;
}

const ToContacted: React.FC<IProps> = ({ book, id, label = 'Title' }) => {
  const { setAction } = useActions();

  return (
    <Popover
      placement='topLeft'
      content={<div className='popover-content'>{`Send ${label} to Contacted`}</div>}
      trigger='hover'
    >
      <PhoneOutlined
        data-testid='action-contacted-item'
        onClick={(e) => {
          e.stopPropagation();
          globalThis.gtag('event', GAEventName.click, {
            identifier: GAEventIdentifier.titletoContacted,
            value: book.ASIN,
            book_name: book.Title
          });
          setAction({ book, id, type: ACTIONS.contacted });
        }}
        className='actions-icons actions-icons-contact'
      />
    </Popover>
  );
};

export default React.memo(ToContacted);